/** Used in dynamic component mapping - Every ModalComponent name must be defined here */
export enum ModalContent {
  AddNewSessionForm = "AddNewSessionForm",
  UpdateAvatar = "UpdateAvatar",
  Confirmation = "Confirmation",
  EditSessionForm = "EditSessionForm",
  EditQuestionForm = "EditQuestionForm",
  AddQuestionForm = "AddQuestionForm"
}
